import { Component, Input, OnInit, Output } from '@angular/core';
import { Message, MessageService } from 'primeng/api';
import { error } from 'console';
import { EventEmitter } from 'stream';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss'],

})
export class ErrorMessageComponent implements OnInit {
  isError: boolean = false;
  errormsg: Message[];
  @Input()error;
  // @Output() close = new EventEmitter();

  constructor(private messageservice: MessageService) { }

  ngOnInit(): void {
    this.errormsg = [

      {severity:'success',detail:'Data Uploaded Successfully.'},
      // {severity:'error',summary: 'Error',detail:'Data Not Uploaded.'},
      
    ];

    // error => {
    //   this.isError = true;

    // }
  }
  onCloseClick()
  {
    // this.close.emit;
  }

}
